export const functionDetails = [
  {
    name: "ABS",
    summary: "Returns the absolute value of a number.",
    example: ["-2"],
    params: [
      {
        name: "value",
        summary: "The number of which to return the absolute value.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ACOS",
    summary: "Returns the inverse cosine of a value, in radians.",
    example: ["1"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the inverse cosine. Must be between -1 and 1, inclusive.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ACOSH",
    summary: "Returns the inverse hyperbolic cosine of a number.",
    example: ["2"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the inverse hyperbolic cosine. Must be greater than or equal to 1.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ASIN",
    summary: "Returns the inverse sine of a value, in radians.",
    example: ["0"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the inverse sine. Must be between -1 and 1, inclusive.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ASINH",
    summary: "Returns the inverse hyperbolic sine of a number.",
    example: ["0.9"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the inverse hyperbolic sine.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ATAN",
    summary: "Returns the inverse tangent of a value, in radians.",
    example: ["1"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the inverse tangent.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ATAN2",
    summary: "Returns the angle between the x-axis and a line segment from the origin (0,0) to specified coordinate pair (x,y), in radians.",
    example: ["x", "y"],
    params: [
      {
        name: "x",
        summary: "The x coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "y",
        summary: "The y coordinate of the endpoint of the line segment for which to calculate the angle from the x-axis.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ATANH",
    summary: "Returns the inverse hyperbolic tangent of a number.",
    example: ["0.6"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the inverse hyperbolic tangent. Must be between -1 and 1, exclusive.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "CEILING",
    summary: "Returns the smallest integer greater than or equal to a given number.",
    example: ["7.45"],
    params: [
      {
        name: "value",
        summary: "The value to round up to the nearest integer.",
        optional: false,
        repeatable: false
      }
    ],
    type: "math"
  },
  {
    name: "COS",
    summary: "Returns the cosine of an angle provided in radians.",
    example: ["PI()"],
    params: [
      {
        name: "angle",
        summary: "The angle to find the cosine of, in radians.",
        optional: false,
        repeatable: false
      }
    ],
    type: "math"
  },
  {
    name: "COSH",
    summary: "Returns the cosine of an angle provided in radians.",
    example: ["1"],
    params: [
      {
        name: "value",
        summary: "Any real value to calculate the hyperbolic cosine of.",
        optional: false,
        repeatable: false
      }
    ],
    type: "math"
  },
  {
    name: "EXP",
    summary: "Returns Euler's number, e (~2.718) raised to a power.",
    example: ["2"],
    params: [
      {
        name: "exponent",
        summary: "The exponent to raise e to.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "FLOOR",
    summary: "Returns the largest integer less than or equal to a given number.",
    example: ["45.95"],
    params: [
      {
        name: "value",
        summary: "The value to round down to the nearest integer.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ISEVEN",
    summary: "Checks whether the provided value is even.",
    example: ["4"],
    params: [
      {
        name: "value",
        summary: "The value to be verified as even.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ISODD",
    summary: "Checks whether the provided value is odd.",
    example: ["4"],
    params: [
      {
        name: "value",
        summary: "The value to be verified as odd.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "LN",
    summary: "Returns the the logarithm of a number, base e (Euler's number).",
    example: ["100"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the logarithm, base e.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "LOG",
    summary: "Returns the the logarithm of a number given a base.",
    example: ["128", "2"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the logarithm given base.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "base",
        summary: "The base to use for calculation of the logarithm.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "LOG10",
    summary: "Returns the the logarithm of a number, base 10.",
    example: ["100"],
    params: [
      {
        name: "value",
        summary: "The value for which to calculate the logarithm, base 10.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "MOD",
    summary: "Returns the result of the modulo operator, the remainder after a division operation.",
    example: ["10", "4"],
    params: [
      {
        name: "dividend",
        summary: "The number to be divided to find the remainder.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "divisor",
        summary: "The number to divide by.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "PI",
    summary: "Returns the value of Pi to 15 decimal places.",
    example: [],
    params: [],
    type: "math"
  },
  {
    name: "POWER",
    summary: "Returns a number raised to a power.",
    example: ["2", "10"],
    params: [
      {
        name: "base",
        summary: "The number to raise to the exponent power.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "exponent",
        summary: "The exponent to raise base to.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "RAND",
    summary: "Returns a random number between 0 inclusive and 1 exclusive.",
    example: [],
    params: [],
    type: "math"
  },
  {
    name: "ROUND",
    summary: "Returns the value of a number rounded to the nearest integer.",
    example: ["99.25"],
    params: [
      {
        name: "value",
        summary: "The value to round to the nearest integer.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },

  {
    name: "SIN",
    summary: "Sine of an angle provided on radians.",
    example: ["PI()"],
    params: [
      {
        name: "angle",
        summary: "The angle to find the sine of, in radians.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "SINH",
    summary: "Returns the hyperbolic sine of any real number.",
    example: ["1"],
    params: [
      {
        name: "value",
        summary: "Any real value to calculate the hyperbolic sine of.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "SQRT",
    summary: "Returns the positive square root of a positive number.",
    example: ["9"],
    params: [
      {
        name: "value",
        summary: "The number for which to calculate the positive square root.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "SUM",
    summary: "Returns the sum of a series of numbers and/or cells.",
    example: ["10", "20"],
    params: [
      {
        name: "value1",
        summary: "The first number or cell to add together.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "value2",
        summary: "Additional numbers or cells to add to value1.",
        optional: true,
        repeatable: true,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "MIN",
    summary: "Returns the minimum value in a numeric dataset.",
    example: ["5", "4"],
    params: [
      {
        name: "value1",
        summary: "The first value or range to consider when calculating the minimum value.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "value2",
        summary: "Additional values to consider when calculating the minimum value",
        optional: true,
        repeatable: true,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "MAX",
    summary: "Returns the maximum value in a numeric dataset.",
    example: ["2", "5", "3"],
    params: [
      {
        name: "value1",
        summary: "The first value or range to consider when calculating the maximum value.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "value2",
        summary: "Additional values to consider when calculating the maximum value",
        optional: true,
        repeatable: true,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "TAN",
    summary: "Returns the tangent of an angle provided in radians.",
    example: ["PI()"],
    params: [
      {
        name: "angle",
        summary: "The angle to find the tangent of, in radians.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "TANH",
    summary: "Returns the hyperbolic tangent of any real number.",
    example: ["1"],
    params: [
      {
        name: "value",
        summary: "Any real value to calculate the hyperbolic tangent of.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "math"
  },
  {
    name: "ACCRINT",
    summary: "Calculates the accrued interest of a security that has periodic payments.",
    example: ["'2/2/2012'", "'3/30/2012'", "'12/4/2013'", "0.1", "1000", "1", "0"],
    params: [
      {
        name: "issue",
        summary: "The date the security was initially issued.",
        optional: false,
        repeatable: false,
        type: 'date'
      },
      {
        name: "first_payment",
        summary: " The first date interest will be paid.",
        optional: false,
        repeatable: false,
        type: 'date'
      },
      {
        name: "settlement",
        summary: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
        optional: false,
        repeatable: false,
        type: 'date'
      },
      {
        name: "rate",
        summary: "The annualized rate of interest.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "redemption",
        summary: "The redemption amount per 100 face value, or par.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "frequency",
        summary: "The number of interest or coupon payments per year (1, 2, or 4).",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "day_count_convention",
        summary: "[0 by default] An indicator of what day count method to use.",
        optional: true,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "CUMIPMT",
    summary: "Calculates the cumulative interest over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    example: [0.12, 12, 100, 1, 5, 0],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "number_of_periods ",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "first_period",
        summary: "The number of the payment period to begin the cumulative calculation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "last_period",
        summary: "The number of the payment period to end the cumulative calculation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "end_or_beginning",
        summary: "Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "CUMPRINC",
    summary: "Calculates the cumulative principal paid over a range of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    example: [0.12, 12, 100, 1, 5, 0],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "first_period",
        summary: "The number of the payment period to begin the cumulative calculation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "last_period",
        summary: "The number of the payment period to end the cumulative calculation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "end_or_beginning",
        summary: "Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "DB",
    summary: "Calculates the depreciation of an asset for a specified period using the arithmetic declining balance method.",
    example: [100, 50, 10, 2],
    params: [
      {
        name: "cost",
        summary: "The initial cost of the asset.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "salvage",
        summary: "The value of the asset at the end of depreciation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "life",
        summary: "The number of periods over which the asset is depreciated.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "period",
        summary: "The single period within life for which to calculate depreciation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "month",
        summary: "[12 by default] The number of months in the first year of depreciation.",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "DDB",
    summary: "Calculates the depreciation of an asset for a specified period using the double-declining balance method.",
    example: [100, 50, 10, 2],
    params: [
      {
        name: "cost",
        summary: "The initial cost of the asset.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "salvage",
        summary: "The value of the asset at the end of depreciation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "life",
        summary: "The number of periods over which the asset is depreciated.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "period",
        summary: "The single period within life for which to calculate depreciation.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "factor",
        summary: "[2 by default] The factor by which depreciation decreases.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "DOLLARDE",
    summary: "Converts a price quotation given as a decimal fraction into a decimal value.",
    example: [100.10, 32],
    params: [
      {
        name: "fractional_price",
        summary: "The price quotation given using fractional decimal conventions.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "unit",
        summary: "The units of the fraction, e.g. 8 for 1/8ths or 32 for 1/32nds.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "DOLLARFR",
    summary: "Converts a price quotation given as a decimal value into a decimal fraction.",
    example: [100.10, 32],
    params: [
      {
        name: "fractional_price",
        summary: "The price quotation given using fractional decimal value.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "unit",
        summary: "The units of the fraction, e.g. 8 for 1/8ths or 32 for 1/32nds.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "EFFECT",
    summary: "Calculates the annual effective interest rate given the nominal rate and number of compounding periods per year.",
    example: [0.99, 12],
    params: [
      {
        name: "nominal_rate",
        summary: "The nominal interest rate per year.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "periods_per_year ",
        summary: "The number of compounding periods per year.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "FV",
    summary: "Calculates the future value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    example: [2, 12, 100, 400],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "payment_amount",
        summary: "The amount per period to be paid.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "FVSCHEDULE",
    summary: "Calculates the future value of some principal based on a specified series of potentially varying interest rates.",
    example: [100, "[0.09, 0.1, 0.11]"],
    params: [
      {
        name: "principal",
        summary: "The amount of initial capital or value to compound against.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "rate_schedule",
        summary: "A series of interest rates to compound against the principal.",
        optional: false,
        repeatable: false,
        type: 'string'
      }
    ],
    type: "financial"
  },
  {
    name: "IPMT",
    summary: "Calculates the payment on interest for an investment based on constant-amount periodic payments and a constant interest rate.",
    example: ["0.05/12", 1, "30*12", 100000, 1000000, 0],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "period",
        summary: "The amortization period, in terms of number of periods.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "future_value",
        summary: "The future value remaining after the final payment has been made.",
        optional: true,
        repeatable: false,
        type: 'number'
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "IRR",
    summary: "Calculates the internal rate of return on an investment based on a series of periodic cash flows.",
    example: ["[-4000, 200, 250, 300, 350]", 0.1],
    params: [
      {
        name: "cashflow_amounts",
        summary: "An array or range containing the income or payments associated with the investment.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "rate_guess",
        summary: "[0 by default] An estimate for what the internal rate of return will be.",
        optional: true,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "MIRR",
    summary: "Calculates the modified internal rate of return on an investment based on a series of periodic cash flows and the difference between the interest rate paid on financing versus the return received on reinvested income.",
    example: ["[-4000, 200, 250, 300, 350]", 0.08, 0.11],
    params: [
      {
        name: "cashflow_amounts",
        summary: "An array or range containing the income or payments associated with the investment.",
        optional: false,
        repeatable: false,
        type: 'string'
      },
      {
        name: "financing_rate",
        summary: "The interest rate paid on funds invested.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "reinvestment_return_rate",
        summary: "The return (as a percentage) earned on reinvestment of income received from the investment.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "NOMINAL",
    summary: "Calculates the annual nominal interest rate given the effective rate and number of compounding periods per year.",
    example: [0.85, 12],
    params: [
      {
        name: "effective_rate",
        summary: "The effective interest rate per year.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "periods_per_year ",
        summary: "The number of compounding periods per year.",
        optional: false,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "NPER",
    summary: "Calculates the number of payment periods for an investment based on constant-amount periodic payments and a constant interest rate.",
    example: [2, 500, 40000],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "payment_amount",
        summary: "The amount of each payment made.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false,
        type: 'number'
      },
      {
        name: "future_value",
        summary: " The future value remaining after the final payment has been made.",
        optional: true,
        repeatable: false,
        type: 'number'
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false,
        type: 'number'
      }
    ],
    type: "financial"
  },
  {
    name: "NPV",
    summary: "Calculates the net present value of an investment based on a series of periodic cash flows and a discount rate.",
    example: [0.08, 200, 250, 300],
    params: [
      {
        name: "discount",
        summary: "The discount rate of the investment over one period.",
        optional: false,
        repeatable: false
      },
      {
        name: "cashflow1",
        summary: "The first future cash flow.",
        optional: false,
        repeatable: false
      },
      {
        name: "cashflow2",
        summary: "Additional future cash flows.",
        optional: true,
        repeatable: true
      }
    ],
    type: "financial"
  },
  {
    name: "PMT",
    summary: "Calculates the periodic payment for an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    example: ["0.05/12", "30*12", 100000],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false
      },
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false
      },
      {
        name: "future_value",
        summary: " The future value remaining after the final payment has been made.",
        optional: true,
        repeatable: false
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "PPMT",
    summary: "Calculates the payment on the principal of an investment based on constant-amount periodic payments and a constant interest rate.",
    example: ["0.05/12", "30*12", 100000],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false
      },
      {
        name: "period",
        summary: "The amortization period, in terms of number of periods.",
        optional: false,
        repeatable: false
      },
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false
      },
      {
        name: "future_value",
        summary: " The future value remaining after the final payment has been made.",
        optional: true,
        repeatable: false
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "PV",
    summary: "Calculates the present value of an annuity investment based on constant-amount periodic payments and a constant interest rate.",
    example: [2, 12, 100],
    params: [
      {
        name: "rate",
        summary: "The interest rate.",
        optional: false,
        repeatable: false
      },
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false
      },
      {
        name: "payment_amount",
        summary: "The amount per period to be paid.",
        optional: false,
        repeatable: false
      },
      {
        name: "future_value",
        summary: " The future value remaining after the final payment has been made.",
        optional: true,
        repeatable: false
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "RATE",
    summary: "Calculates the interest rate of an annuity investment based on constant-amount periodic payments and the assumption of a constant interest rate.",
    example: [12, -100, 400, 0, 0, 0.1],
    params: [
      {
        name: "number_of_periods",
        summary: "The number of payments to be made.",
        optional: false,
        repeatable: false
      },
      {
        name: "payment_per_period",
        summary: " The amount per period to be paid.",
        optional: false,
        repeatable: false
      },
      {
        name: "present_value",
        summary: "The current value of the annuity.",
        optional: false,
        repeatable: false
      },
      {
        name: "future_value",
        summary: " The future value remaining after the final payment has been made.",
        optional: true,
        repeatable: false
      },
      {
        name: "end_or_beginning",
        summary: "[0 by default] Whether payments are due at the end (0) or beginning (1) of each period.",
        optional: true,
        repeatable: false
      },
      {
        name: "rate_guess",
        summary: "[0.1 by default] An estimate for what the internal rate of return will be.",
        optional: true,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "SLN",
    summary: "Calculates the depreciation of an asset for one period using the straight-line method.",
    example: [100, 50, 10],
    params: [
      {
        name: "cost",
        summary: "The initial cost of the asset.",
        optional: false,
        repeatable: false
      },
      {
        name: "salvage",
        summary: "The value of the asset at the end of depreciation.",
        optional: false,
        repeatable: false
      },
      {
        name: "life",
        summary: "The number of periods over which the asset is depreciated.",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "SYD",
    summary: "Calculates the depreciation of an asset for a specified period using the sum of years digits method.",
    example: [100, 50, 10, 2],
    params: [
      {
        name: "cost",
        summary: "The initial cost of the asset.",
        optional: false,
        repeatable: false
      },
      {
        name: "salvage",
        summary: "The value of the asset at the end of depreciation.",
        optional: false,
        repeatable: false
      },
      {
        name: "life",
        summary: "The number of periods over which the asset is depreciated.",
        optional: false,
        repeatable: false
      },
      {
        name: "period",
        summary: "The single period within life for which to calculate depreciation.",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "TBILLEQ",
    summary: "Calculates the equivalent annualized rate of return of a US Treasury Bill based on discount rate.",
    example: ["'03/31/2014'", "'06/01/2014'", 0.0914],
    params: [
      {
        name: "settlement",
        summary: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
        optional: false,
        repeatable: false
      },
      {
        name: "maturity",
        summary: "The maturity or end date of the security, when it can be redeemed at face or par value.",
        optional: false,
        repeatable: false
      },
      {
        name: "discount",
        summary: " The discount rate of the bill at time of purchase.",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "TBILLPRICE",
    summary: "Calculates the price of a US Treasury Bill based on discount rate.",
    example: ["'03/31/2014'", "'06/01/2014'", 1.25],
    params: [
      {
        name: "settlement",
        summary: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
        optional: false,
        repeatable: false
      },
      {
        name: "maturity",
        summary: "The maturity or end date of the security, when it can be redeemed at face or par value.",
        optional: false,
        repeatable: false
      },
      {
        name: "discount",
        summary: " The discount rate of the bill at time of purchase.",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "TBILLYIELD",
    summary: "Calculates the yield of a US Treasury Bill based on price.",
    example: ["'1/2/2014'", "'12/31/2014'", 98.45],
    params: [
      {
        name: "settlement",
        summary: "The settlement date of the security, the date after issuance when the security is delivered to the buyer.",
        optional: false,
        repeatable: false
      },
      {
        name: "maturity",
        summary: "The maturity or end date of the security, when it can be redeemed at face or par value.",
        optional: false,
        repeatable: false
      },
      {
        name: "discount",
        summary: "The price at which the security is bought.",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "XIRR",
    summary: "Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",
    example: ["[-10000,2750,4250,3250,2750]", "'01/jan/08'", "'01/mar/08'", "'30/oct/08'", "'15/feb/09'", "'01/apr/09'", 0.1],
    params: [
      {
        name: "cashflow_amounts",
        summary: "An array or range containing the income or payments associated with the investment.",
        optional: false,
        repeatable: false
      },
      {
        name: "cashflow_dates",
        summary: "An array or range with dates corresponding to the cash flows in",
        optional: false,
        repeatable: false
      },
      {
        name: "rate_guess",
        summary: "[0.1 by default] An estimate for what the internal rate of return will be.",
        optional: true,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "XNPV",
    summary: "Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",
    example: [0.09, "[-10000,2750,4250,3250,2750]", "'01/jan/08'", "'01/mar/08'", "'30/oct/08'", "'15/feb/09'", "'01/apr/09'"],
    params: [
      {
        name: "discount",
        summary: "The discount rate of the investment over one period.",
        optional: false,
        repeatable: false
      },
      {
        name: "cashflow_amounts",
        summary: "An array or range containing the income or payments associated with the investment.",
        optional: false,
        repeatable: false
      },
      {
        name: "cashflow_dates",
        summary: "An array or range with dates corresponding to the cash flows in",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "YieldNSS",
    summary: "Calculates the internal rate of return of an investment based on a specified series of potentially irregularly spaced cash flows.",
    example: ["beta0", "beta1", "beta2", "beta3", "lambda1", "lambda2", "m"],
    params: [
      {
        name: "beta0",
        summary: "",
        optional: false,
        repeatable: false
      },
      {
        name: "beta1",
        summary: "",
        optional: false,
        repeatable: false
      },
      {
        name: "beta2",
        summary: "",
        optional: false,
        repeatable: false
      },
      {
        name: "beta3",
        summary: "",
        optional: false,
        repeatable: false
      },
      {
        name: "lambda1",
        summary: "",
        optional: false,
        repeatable: false
      },
      {
        name: "lambda2",
        summary: "",
        optional: false,
        repeatable: false
      },
      {
        name: "m",
        summary: "",
        optional: false,
        repeatable: false
      }
    ],
    type: "financial"
  },
  {
    name: "addDay",
    summary: "Add the specified number of days to the given date.",
    example: ["now()", "2"],
    params: [
      {
        name: "date",
        summary: "The date to be changed",
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: "amount",
        summary: "The amount of days to be added",
        optional: false,
        repeatable: false,
        type: "number"
      }
    ],
    type: "date"
  },
  {
    name: "addBusinessDay",
    summary: "Add a specified number of weekdays to the given date.",
    example: ["now()", "2"],
    params: [
      {
        name: "date",
        summary: "The date to be changed",
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: "amount",
        summary: "The amount of weekdays to be added",
        optional: false,
        repeatable: false,
        type: "number"
      }
    ],
    type: "date"
  },
  {
    name: "getNoOfDays",
    summary: "Get the number of full day periods between the given dates.",
    example: ["dateLeft", "dateRight"],
    params: [
      {
        name: "dateLeft",
        summary: "The later date",
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: "dateRight",
        summary: "The earlier date",
        optional: false,
        repeatable: false,
        type: "date"
      }
    ],
    type: "date"
  },
  {
    name: "getNoOfBusinessDays",
    summary: "Get the number of full weekdays periods between the given dates.",
    example: ["dateLeft", "dateRight"],
    params: [
      {
        name: "dateLeft",
        summary: "The later date",
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: "dateRight",
        summary: "The earlier date",
        optional: false,
        repeatable: false,
        type: "date"
      }
    ],
    type: "date"
  },
  {
    name: "startOfMonth",
    summary: "Return the start of a month for the given month and year. The result will be in the local timezone.",
    example: ["12", "2018"],
    params: [
      {
        name: "month",
        summary: "The month",
        optional: false,
        repeatable: false,
        type: "number"
      },
      {
        name: "year",
        summary: "The year",
        optional: false,
        repeatable: false,
        type: "number"
      }
    ],
    type: "date"
  },
  {
    name: "endOfMonth",
    summary: "Return the end of a month for the given month and year. The result will be in the local timezone.",
    example: ["12", "2018"],
    params: [
      {
        name: "month",
        summary: "The month",
        optional: false,
        repeatable: false,
        type: "number"
      },
      {
        name: "year",
        summary: "The year",
        optional: false,
        repeatable: false,
        type: "number"
      }
    ],
    type: "date"
  },
  {
    name: "setTime",
    summary: "Set the time to the given date.",
    example: ["now()", "2017-10-24T00:00:00"],
    params: [
      {
        name: "date",
        summary: "The date to be changed",
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: "date",
        summary: "The date to set time.",
        optional: false,
        repeatable: false,
        type: "date"
      }
    ],
    type: "date"
  },
  {
    name: "now",
    summary: "Return the current date as a string in simplified extended ISO format",
    example: ["TSCalculate(DatasetId, Field, From, To, 1, 1, 3 )"],
    params: [],
    type: "date"
  },
  {
    name: "TSCalculate",
    summary: "TSCalculate",
    example: ["now()"],
    params: [
      {
        name: 'datasetId',
        summary: 'Dataset Id',
        optional: false,
        repeatable: false,
        type: "string"
      },
      {
        name: 'fieldId',
        summary: 'Field Id',
        optional: false,
        repeatable: false,
        type: "string"
      },
      {
        name: 'startTime',
        summary: 'Start time',
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: 'endTime',
        summary: 'End Time',
        optional: false,
        repeatable: false,
        type: "date"
      },
      {
        name: 'timeWindowQuantity',
        summary: 'Time Window Quantity',
        optional: false,
        repeatable: false,
        type: "number"
      },
      {
        name: 'timeWindowUnit',
        summary: 'Time Window Unit',
        optional: false,
        repeatable: false,
        type: "number"
      },
      {
        name: 'functionType',
        summary: 'Function Type',
        optional: false,
        repeatable: false,
        type: "number"
      },
      {
        name: 'repeatTimeQuantity',
        summary: 'repeatTimeQuantity',
        optional: true,
        repeatable: false,
        type: "number"
      },
      {
        name: 'repeatTimeUnit',
        summary: 'repeatTimeUnit',
        optional: true,
        repeatable: false,
        type: "number"
      },
      {
        name: 'includeRealtimeUpdate',
        summary: '[false by default] includeRealtimeUpdate.',
        optional: true,
        repeatable: false,
        type: "boolean"
      },
      {
        name: 'businessDayOnly',
        summary: '[false by default] businessDayOnly.',
        optional: true,
        repeatable: false,
        type: "boolean"
      },
      {
        name: 'emitEmptyWindow',
        summary: '[false by default] emitEmptyWindow.',
        optional: true,
        repeatable: false,
        type: "boolean"
      }
    ],
    type: "function"
  }
];


// WEBPACK FOOTER //
// ./src/core/constants/functionDescription.js